import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Information from '../../../../Shared/Card/Information';
import { GetAppInformationContent } from '../../../../Shared/InformationContent/EFInformation';
import applicationService from '../../../../../services/Internal/Application/application.service';
import efApplicationService from '../../../../../services/Internal/Application/EF/efApplication.service';
import { useSelector } from 'react-redux';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import ReviewPdf from '../../../../Shared/Card/ReviewPdf';
import entityService from '../../../../../services/Internal/Staff/entity.service';
import { Form } from 'rsuite';
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons';
import FormEntityInformation from '../../../Shared/FormEntityInformation';

function ReviewPage() {
    const [hasLoaded, setHasLoaded] = useState(true)
    const push = useNavigate();
    const appId = useSelector(x => x.currentApplicationId);
    const routes = useSelector(x => x.currentRoutes);
    const [violationIssuesHtml, setViolationIssuesHtml] = useState();
    const [isComplete, setIsComplete] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Engineering Firm Application",
            isIndividual: false,
            entityId: 0,
            applicationDate: "",
            currentSection: "Review"
        }
    );
    const sectionId = 9;
    useEffect(() => {
        efApplicationService.efGetSection(appId, sectionId).then((response) => {
            setIsComplete(response.data.staffReviewComplete);
            efApplicationService.getFirmApplication(appId).then((data) => {
                setIsUserEditable(data.data.status.id == 2)
                entityService.getEntity(response.data.entityId).then((entity) => {
                    setEntityInfo(
                        {
                            ...entityInfo,
                            lolaNum: entity.data.lolaNumber,
                            entityName: entity.data.formattedName,
                            entityId: entity.data.entityId,
                            licenseNumber: data.data?.credential?.formattedLicenseNumber,
                            applicationDate: data.data?.dateSubmitted
                        })
                    setHasLoaded(true);
                });
            })
        })
    }, [])

    const formSubmit = () => {
        if (!isUserEditable) {
            push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
        }
        else {
            efApplicationService.efMarkSectionComplete(appId, sectionId, isComplete).then((data) => {
                if (data.data)
                    push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
            })
        }
    }

    return (
        <div>
            <Container fluid>
                <FormEntityInformation {...entityInfo} />
                <Row>
                    <Col>
                        <Information content={GetAppInformationContent("review")} className="mb-3" />
                    </Col>
                </Row>
                <br />
                <ReviewPdf id={appId} parentTypeId={1} />
                <br />
                <br />
                {hasLoaded ?
                    <>
                        {violationIssuesHtml}
                        <Container fluid>
                            <Form onSubmit={formSubmit}>
                                <FormActionButtons
                                    isUserEditable={isUserEditable}
                                    isComplete={isComplete}
                                    isCompleteCallback={setIsComplete}
                                    showSectionComplete={true}
                                    backToSectionLink="/internal/efapp/sections" />
                            </Form>
                        </Container>
                    </>
                    : <LoadingSpinner />
                }
            </Container>
        </div>
    );
}
export default ReviewPage